
type Plugin = (client: any) => any
let HttpClientPlugins: Plugin[] = [];

export default HttpClientPlugins;